import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EmployeeVisitsState, EmployeeVisitsStore } from './employeeVisits.store';

@Injectable({
  providedIn: 'root',
})
export class EmployeeVisitsQuery extends QueryEntity<EmployeeVisitsState> {
  constructor(protected override store: EmployeeVisitsStore) {
    super(store);
  }
}
